export default __webpack_public_path__ + "static/media/dna.facdfed0.png";